import { render, staticRenderFns } from "./Guardian.vue?vue&type=template&id=57297554&"
import script from "./Guardian.vue?vue&type=script&lang=js&"
export * from "./Guardian.vue?vue&type=script&lang=js&"
import style0 from "./Guardian.vue?vue&type=style&index=0&id=57297554&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports